<mat-card class="feed-card">
    <div class="post-body" (ngxVisibility)="updateVisibility($event)" [ngxVisibilityThreshold]="1">
        <div class="feed-card-header">
            <span class="feed-card-icon"><mat-icon>article</mat-icon></span>
            <div class="feed-card-heading">
                <div class="feed-card-title-row">
                    <h3 class="feed-card-title">{{ post.title }}</h3>
                    <span class="bg-label other mat-small" *ngIf="showTargetUser && post.hasTargetUser">Destinatário definido</span>
                </div>
                <span class="feed-card-meta">
                    <span>{{ post.postDate | date:"dd/MM/yyyy 'às' HH:mm" }}</span>
                    <ng-container *ngIf="post.createdBy != null"><span>·</span><span>{{ post.createdBy }}</span></ng-container>
                    <ng-container *ngIf="post.edited"><span>·</span><mat-icon>edit</mat-icon><span>Editado</span></ng-container>
                </span>
            </div>
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Opções da publicação"
                *ngIf="allowPostManagement && (post.allowEdition || allowEditingAnyPost)">
                <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editPost()">
                    <mat-icon>create</mat-icon>
                    <span>Editar</span>
                </button>
                <button mat-menu-item (click)="deletePost()">
                    <mat-icon>delete</mat-icon>
                    <span>Excluir</span>
                </button>
            </mat-menu>
        </div>

        <div class="post-description" *ngIf="post.description">
            <p class="feed-card-text" [class.collapsed]="isLongDescription && !expanded"
                [innerHTML]="getPostDescription(post)"></p>
            <button type="button" class="post-description-toggle" *ngIf="isLongDescription" (click)="expanded = !expanded">
                {{ expanded ? 'Ler menos' : 'Ler mais' }}
            </button>
        </div>

        <div class="post-content" *ngIf="post.attachments?.length > 0">
            <app-frame-file class="frame" [filePath]="post.attachments[post.selectedAttachmentIndex ?? 0].filePath"
                [fileType]="post.attachments[post.selectedAttachmentIndex ?? 0].fileType"
                [index]="post.selectedAttachmentIndex ?? 0" [total]="post.attachments.length"
                (indexChange)="post.selectedAttachmentIndex = $event"></app-frame-file>
            <div class="attachments-carrousel" *ngIf="post.attachments?.length > 1">
                <button type="button" *ngFor="let attachment of post.attachments" class="carrousel-item"
                    (click)="selectCarrouselAttachment(attachment)"
                    [class.selected]="(post.selectedAttachmentIndex ?? 0) == post.attachments.indexOf(attachment)">
                    <img [src]="attachment.filePath | safe: 'resourceUrl'" *ngIf="isFileImage(attachment.fileType)" alt="">
                    <iframe [src]="attachment.filePath | safe: 'resourceUrl'" tabindex="-1"
                        *ngIf="!isFileImage(attachment.fileType) && !isFileVideo(attachment.fileType)"></iframe>
                    <img src="assets/images/video.png" *ngIf="isFileVideo(attachment.fileType)" alt="">
                </button>
            </div>
        </div>

        <!-- Extra content from the page, e.g. the legal posts' acceptance term -->
        <ng-content select="[postExtra]"></ng-content>
    </div>

    <div class="feed-card-footer">
        <button type="button" class="like-button" [class.liked]="post.isLiked" (click)="ratePost()"
            [attr.aria-pressed]="post.isLiked" aria-label="Curtir">
            <mat-icon>{{ post.isLiked ? 'favorite' : 'favorite_border' }}</mat-icon>
            <span>{{ post.likedByCount }}</span>
        </button>
        <span class="feed-card-stat">
            <mat-icon>visibility</mat-icon>
            {{ post.readByCount }} {{ post.readByCount == 1 ? 'visualização' : 'visualizações' }}
        </span>
    </div>

    <!-- Statistics from the page, shown below the footer -->
    <ng-content select="[postStats]"></ng-content>
</mat-card>
